/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { getUrlWithoutSearchParams } from "bundle/util/UriUtils";
import { getCurrentEnv, isValidUrl } from "bundle/util/EnvUtil";

const WHITELIST_DOMAIN_FOR_PRIVATE_APIS_PROD = [
    ".acrobat.com",
    ".adobe.com",
    ".adobeprojectm.com",
];

const WHITELIST_DOMAIN_FOR_PRIVATE_APIS = [
    ".adobecc.com",
    ".echocdnawspreview.com",
    ".echocdnstage.com",
    ...WHITELIST_DOMAIN_FOR_PRIVATE_APIS_PROD,
];

const isValidAllowedURL = (checkURL, domainLists) => {
    if (!isValidUrl(checkURL)) {
        return false;
    }

    try {
        const url = new URL(checkURL);
        const hostname = url.hostname;
        let noRestriction = false;

        let listOfDomains;

        if (domainLists) {
            listOfDomains = domainLists;
        } else {
            const env = getCurrentEnv(getUrlWithoutSearchParams(window.location.href));
            listOfDomains = env === "prod"
                ? WHITELIST_DOMAIN_FOR_PRIVATE_APIS_PROD : WHITELIST_DOMAIN_FOR_PRIVATE_APIS;
        }

        listOfDomains.forEach(domain => {
            if (hostname.indexOf(domain, hostname.length - domain.length) !== -1) {
                noRestriction = true;
            }
        });

        return noRestriction;
    } catch (e) {
        return false;
    }
};

export {
    // eslint-disable-next-line import/prefer-default-export
    isValidAllowedURL,
};
